import VerticalTabBar from './VerticalTabBar'

export default VerticalTabBar
